import request from '@/utils/request'
import { baseUrl1, baseUrl2, baseUrl4 } from "./baseUrl";
import qs from 'qs'
//示例
// export function downloadUser(params) {
//   return request({
//     url: 'api/users/download',	//请求方式
//     method: 'get',		//请求路径
//     params,			//该参数可不传
//     responseType: 'blob'	//该参数可不传
//   })
// }

//角色管理；
//获取当前用户角色列表-有页签
export function getRoleDetailList(params) {
    return request({
        url: baseUrl1 + '/api/role/getRoleDetailList',
        method: 'get',
        params,
    })
}

//编辑获取角色详情
export function getRoleDetailsById(params) {
    return request({
        url: baseUrl1 + '/api/role/getRoleDetailsById',
        method: 'get',
        params,
    })
}

export function getAllRoleListByUid(params) {
  return request({
      url: baseUrl1 + '/api/role/getAllRoleListByUid',
      method: 'get',
      params,
  })
}

//获取登录用户拥有的权限树；
export function getUserRoleMenuDetails(params) {
    return request({
        url: baseUrl1 + '/api/role/getUserRoleMenuDetails',
        method: 'get',
        params,
    })
}


//新建-保存角色；
export function saveCrmRole(params) {
    return request({
        url: baseUrl1 + '/api/role/saveCrmRole',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}

//编辑-保存角色；
export function editCrmRole(params) {
    return request({
        url: baseUrl1 + '/api/role/editCrmRole',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}
// 保存角色
export const SaveRole = (params) => {
    return request({
        url: baseUrl1 + '/api/role/save',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}


//组织架构；
//获取全部组织架构树及成员信息
export function getAllDeptAndUser(params) {
    return request({
        url: baseUrl1 + '/api/dept/getAllDeptAndUser',
        method: 'get',
        params,
    })
}
//获取当前用户组织架构树及成员信息
export function getDeptAndUser(params) {
    return request({
        url: baseUrl1 + '/api/dept/getAllDeptAndUser',
        method: 'get',
        params,
    })
}



//获取登录用户下级的组织架构树及成员信息
export function getDeptAndUserDistinguishManager() {
    return request({
        url: baseUrl1 + '/api/dept/getDeptAndUserDistinguishManager',
        method: 'get',
    })
}

//编辑组织架构节点
export function editDept(params) {
    return request({
        url: baseUrl1 + '/api/dept/editDept',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}

//保存组织架构节点
export function saveDept(params) {
    return request({
        url: baseUrl1 + '/api/dept/saveDept',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}

//删除组织架构节点
export function deleteDeptById(params) {
    return request({
        url: baseUrl1 + '/api/dept/deleteDeptById',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}

//用户管理；
//获取用户列表；
export function getUserLists(params) {
    return request({
        url: baseUrl1 + '/api/user/getUserLists',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}
//查询获取部门和人员
export function searchDeptAndUser(params) {
    return request({
        url: baseUrl1 + '/api/dept/searchDeptAndUser',
        method: 'get',
        params,
    })
}

//获取当前用户组织架构树；
export function getDeptDetails(params) {
    return request({
        url: baseUrl1 + '/api/dept/getDeptDetails',
        method: 'get',
        params,
    })
}

//获取当前用户的全部角色列表；无页签
export function getRoleList(params) {
    return request({
        url: baseUrl1 + '/api/user/getRoleList',
        method: 'get',
        params,
    })
}


//获取当前用户详情
export function getUserDetailsById(params) {
    return request({
        url: baseUrl1 + '/api/user/getUserDetailsById',
        method: 'get',
        params,
    })
}

//新建保存用户
export function saveCrmUser(params) {
    return request({
        url: baseUrl1 + '/api/user/saveCrmUser',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}

//编辑保存用户
export function editCrmUser(params) {
    return request({
        url: baseUrl1 + '/api/user/editCrmUser',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}

//重置密码
export function resetPassword(params) {
    return request({
        url: baseUrl1 + '/api/user/resetPassword',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}

//保存用户状态
export function updateUserStatus(params) {
    return request({
        url: baseUrl1 + '/api/user/updateUserStatus',
        method: 'post',
        params,
    })
}

//离职
export function updateLeaveStatus(params) {
    return request({
        url: baseUrl1 + '/api/user/updateLeaveStatus',
        method: 'post',
        params,
    })
}


//权限树管理；
//获取权限树结构；
export function getAllMenus(params) {
    return request({
        url: baseUrl1 + '/api/menu/getAllMenus',
        method: 'get',
        params,
    })
}

//新建保存权限树节点
export function saveMenu(params) {
    return request({
        url: baseUrl1 + '/api/menu/saveMenu',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}

//编辑保存权限树节点
export function editMenu(params) {
    return request({
        url: baseUrl1 + '/api/menu/editMenu',
        method: 'post',
        data: params,
        datatype: 'json',
    })
}


// export function login(username, password, code, uuid) {
//   return request({
//     url: baseUrl1 + 'auth/user',
//     method: 'post',
//     data: {
//       username,
//       password,
//       code,
//       uuid
//     }
//   })
// }

//刷新获取用户权限；
export function getInfo() {
    return request({
        url: baseUrl1 + '/api/user/getLoginUserDetails',
        method: 'get'
    })
}

// 编辑用户中获取该用户负责的项目和参与的项目
export function GetEditProjectByUser(data) {
    console.log(request);
    return request({
        // headers: { 'Content-Type': 'form-data' },
        // headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl4 + '/api/project/getResponsibleAndInvolvedProjectList',
        method: 'post',
        params: data
    })
}
// 拉起项目列表
export function GetProjectByUser() {
    return request({
        url: baseUrl4 + '/api/project/getProjectSimpleList',
        method: 'post',
    })
}

export function getTeamFollowUpData(params) {
    return request({
        url: baseUrl2 + '/api/data/getTeamFollowUpData',
        params
        // url: baseUrl2 + '/api/data/getTeamFollowUpData?' + params,
    })
}

// 跟进结果图表
export function getAppResumeFollowUpChart(params) {
    return request({
        url: baseUrl2 + '/api/followUp/getAppResumeFollowUpChart',
        method: 'post',
        datatype: 'json',
        data: params
    })
}

// 识别统计详情
export function getMailboxEveryDayList(params) {
    return request({
        url: baseUrl1 + '/api/mail/getMailboxEveryDayList',
        method: 'post',
        datatype: 'json',
        data: params
    })
}



// WEBPACK FOOTER //
// ./src/api/user.js